import React, { useState } from "react";
const Token = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    const { left, top, width, height } =
      e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - left) / width - 0.5) * 40; // Scale movement
    const y = ((e.clientY - top) / height - 0.5) * 40;

    setPosition({ x: -x, y: -y }); // Inverse movement
  };
  return (
    <>
      <section className="Token" onMouseMove={handleMouseMove}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="content"
                style={{
                  transform: `translate(${position.x}px, ${position.y}px)`,
                }}
              >
                {/* <div data-aos="fade-down" data-aos-duration="2000">
                  <h1>ZEUSS</h1>
                </div> */}
                <div className="zeuss">
                  <img src="/images/zeuss.png" alt="" />
                </div>
                {/* <div data-aos="fade-up" data-aos-duration="2000">
                  <h2>TOKEN</h2>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Token;
